import { render } from "./SkuRating.vue?vue&type=template&id=53210345&scoped=true"
import script from "./SkuRating.vue?vue&type=script&lang=js"
export * from "./SkuRating.vue?vue&type=script&lang=js"

import "./SkuRating.vue?vue&type=style&index=0&id=53210345&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53210345"]])

export default __exports__